<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 25c-5.66 0-10.21-4.59-12.38-8.52a1 1 0 010-1C5.79 11.59 10.34 7 16 7s10.21 4.59 12.38 8.52a1 1 0 010 1C26.21 20.41 21.66 25 16 25zM5.65 16c2 3.33 5.78 7 10.35 7s8.35-3.67 10.35-7c-2-3.33-5.78-7-10.35-7s-8.35 3.67-10.35 7z"/><path d="M16 21.5a5.5 5.5 0 115.5-5.5 5.51 5.51 0 01-5.5 5.5zm0-9a3.5 3.5 0 103.5 3.5 3.5 3.5 0 00-3.5-3.5z"/></svg>